import { OAuth2_Callback } from './oauth2_callback'

export default OAuth2_Callback
